import React from 'react';

function TableCountInfo(props) {
    const total = props.total ?? 0;
    return (
        <small className="text-info">{new Intl.NumberFormat('en').format(total)} {total === 1?'registro':'registros'}</small>
    );
}

export default TableCountInfo;